import { Box, Theme, styled } from '@material-ui/core';

export const TitleWrapper = styled('div')<Theme>(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '1rem',
  marginBottom: theme.spacing(1),
}));

export const PrefixWrapper = styled(Box)({
  '@media print': {
    display: 'none !important',
  },
});

export const StyledNumber = styled('div')<Theme>(({ theme }) => ({
  fontFamily: theme.config.secondaryFontFamily,
  fontSize: theme.typography.h3.fontSize,
  fontWeight: 400,
  lineHeight: 2,
  color: theme.palette.primary.main,
}));
